import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "property-item-row",
  standalone: false,
  templateUrl: "./property-item-row.component.html",
  styleUrl: "./property-item-row.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyItemRowComponent {
  name = input.required<string>();
  value = input.required<string | number>();
}
